import type { EventStatus, ProgramEventStatus } from 'models';
import { Link, Text } from 'ui';

type P = {
  getPathToEventDetail: (id: string) => string;
  id: string;
  status?: EventStatus | ProgramEventStatus;
  title: string;
};

const Title = ({ getPathToEventDetail, id, status, title }: P) => (
  <Link effects={{ focus: true, hover: true, radius: true }} to={getPathToEventDetail(id)} type="link-secondary">
    <Text delete={status === 'canceled'} type="title" weight="bold" withinLink={{ hasHoverEffect: true }}>
      {title}
    </Text>
  </Link>
);

export default Title;
